import ErrorFallback from 'Components/ErrorFallback'
import {
  TicketSaleCreatePage,
  TicketSaleListPage,
  TicketSaleTargetCreatePage,
  TicketSaleTargetEditPage,
  TicketSaleTargetListPage
} from 'Services/SalesManagement/Features/TicketSale/Pages'
import { ErrorBoundary } from 'react-error-boundary'
import { Route, Routes } from 'react-router-dom'

export default function TicketSaleRoot() {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Routes>
        <Route path="qr-group-ticket-sales" element={<TicketSaleListPage />} />
        <Route path="qr-group-ticket-sales/create" element={<TicketSaleCreatePage />} />
        <Route path="ticket-sale-targets" element={<TicketSaleTargetListPage />} />
        <Route path="ticket-sale-targets/create" element={<TicketSaleTargetCreatePage />} />
        <Route path="ticket-sale-targets/:id/edit" element={<TicketSaleTargetEditPage />} />
      </Routes>
    </ErrorBoundary>
  )
}
